import * as React from "react";
import { connect } from "react-redux";
import { FileBrowserFilesContext, FileBrowserFileManager, withContext, getPathFromHeader, } from "@focus/focusUI";
import { useFileBrowserHeaderVF } from "@focus/services";
import { useState, useMemo, useEffect } from "react";
const defaultHeader = { locations: [], extensions: [] };
export const FileBrowserContainerVF = (props) => {
    const { config, element, fetchFiles, isDialogOpen, currentPath, onAccept, onCancel, } = props;
    const [selectedLocation, setSelectedLocation] = useState(0);
    const [loaded, setLoaded] = useState(false);
    const headerConfig = useMemo(() => (Object.assign(Object.assign({}, config), { element })), [config, element]);
    const { value: header, error, status } = useFileBrowserHeaderVF(headerConfig);
    useEffect(() => {
        if (isDialogOpen && !loaded && typeof header.locations !== "undefined") {
            let location = 0;
            if (currentPath) {
                const path = currentPath;
                const locations = header.locations;
                for (let i = 0; i < locations.length; i++) {
                    const locationPath = locations[i].relativeLocation;
                    if (path.startsWith(locationPath)) {
                        location = i;
                        break;
                    }
                }
            }
            fetchFiles({
                relLocation: header.locations[location].relativeLocation,
            });
            setSelectedLocation(location);
            setLoaded(true);
        }
        else if (!props.isDialogOpen && loaded) {
            setLoaded(false);
        }
    }, [header, isDialogOpen, loaded]);
    const clickedLocation = (i) => {
        setSelectedLocation(i);
        if (typeof header.locations !== "undefined") {
            fetchFiles({
                relLocation: header.locations[i].relativeLocation,
            });
        }
    };
    const path = getPathFromHeader(currentPath, selectedLocation, header);
    return (React.createElement(FileBrowserFileManager, { isDialogOpen: isDialogOpen, currentPath: path, header: header || defaultHeader, headerStatus: status, headerError: error, selectedLocation: selectedLocation, onClickedLocation: clickedLocation, onAccept: onAccept, onCancel: onCancel }));
};
const mapDispatchToProps = (dispatch, { __filebrowseritems }) => {
    return {
        fetchFiles: (payload) => dispatch(__filebrowseritems.actions.fetchItem(payload)),
    };
};
const Connected = connect(undefined, mapDispatchToProps)(FileBrowserContainerVF);
const contextConfig = {
    __filebrowseritems: FileBrowserFilesContext,
};
export default withContext(contextConfig)(Connected);
//# sourceMappingURL=FileBrowserContainerVF.js.map